import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  borderRadius: 'md',
  contain: 'paint',
  boxShadow:
    '0px 3px 4px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 2px rgba(255, 255, 255, 1) inset, 0px 0px 0px 3px rgba(200, 178, 119, 1) inset',
  mb: '3',
  border: '0',
  p: '1',

  ...(isNested && {
    mb: '0',
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  border: 0,
  p: '3',
  bg: 'beta.400',

  ...(isNested && {
    py: '0',
    px: '2',
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'beta.400',
  h: '32px',
  color: 'white',
  fontWeight: 'normal',
  fontSize: 'md',
  fontFamily: 'heading',
  p: '2',

  svg: {
    border: '1px',
    borderColor: 'transparent',
    color: 'white',
    borderRadius: '100%',
    boxSize: '20px',
    ml: '1',
  },

  _hover: { bg: 'beta.100' },

  ...(isNested && {
    '&&&': {
      bg: 'beta.400',
      p: '2',
      color: 'white',

      svg: {
        borderColor: 'transparent',
        color: 'white',
      },

      _expanded: {
        color: 'white',
        borderBottomRadius: 0,
      },
    },
  }),

  _expanded: {
    borderBottomRadius: 'none',
    bg: 'beta.400',
    color: 'white',
    borderBottom: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.25)',

    ...(isNested && {
      color: 'white',

      _hover: { bg: 'beta.300' },
    }),
  },
});

export const BoxWrapper: CSSObject = {
  py: '2',
  px: '0',
  borderBottomRadius: '6px',
};
